var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"loading"}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('img',{staticClass:"logo",attrs:{"src":"/images/logo-black.svg","alt":"logo","loading":"eager"}}),_vm._v(" "),_c('Loader')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }